<template>
  <div id="outsideContainer">
    <div class="card-wrapper">
      <div class="card-content">
        <div class="card-items">
          <div class="test-progress" v-if="testItem.studentAnswers">
            {{ currentTestingVocIndex + 1 }}/{{
              testItem.studentAnswers.length
            }}
          </div>
          
          <!-- 显示英文单词 -->
          <div class="test-english-word">
            <h1 class="english-word-text">
              {{ testItem.studentAnswers && testItem.studentAnswers[currentTestingVocIndex] 
                ? testItem.studentAnswers[currentTestingVocIndex].englishText 
                : '' }}
            </h1>
          </div>

          <!-- 开始测试按钮（仅在第一个单词显示） -->
          <div class="start-button-container" v-if="showStartButton">
            <el-button 
              type="primary" 
              size="large"
              @click="handleStartTest"
              style="font-size: 24px; padding: 20px 60px;"
            >
              开始测试
            </el-button>
          </div>

          <!-- 倒计时显示（录音时显示） -->
          <div class="count-down-text" v-if="!showStartButton && showCountDown">
            <voc-count-down
              ref="vocCountDown"
              @on-count-down-finished="handleCountDownFinish"
            />
          </div>
          
          <!-- 录音状态显示 -->
          <div class="test-item" v-if="test.isRecording">
            <div class="recording-indicator">
              <span class="recording-dot"></span>
              <span>正在录音...</span>
            </div>
          </div>

          <!-- 评测中提示 -->
          <div class="test-item" v-if="isEvaluating">
            <div class="evaluating-indicator">
              <span>正在评测中...</span>
            </div>
          </div>

          <!-- 评测结果显示 -->
          <div class="test-item evaluation-result" v-if="testItem.studentAnswers && testItem.studentAnswers[currentTestingVocIndex] && testItem.studentAnswers[currentTestingVocIndex].chivoxEvaluationResult">
            <div class="result-info">
              <p>得分: {{ getEvaluationScore(testItem.studentAnswers[currentTestingVocIndex].chivoxEvaluationResult) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <audio ref="vocaudio"></audio>
    </div>
  </div>
</template>

<script>
import VocCountDown from '../recordtotest/VocCountDown.vue'
import Html5Recorder from 'chivox_h5sdk/src/html5/html5recorder'

export default {
  name: 'SpeakEnglishTestItem',
  components: { VocCountDown },
  data () {
    return {
      decodedQueryObject: null,
      testItem: {},
      currentTestingVocIndex: 0,
      test: {
        isRecording: false,
        recordingCardInitialized: false
      },
      initialCountDownSetting: 5,
      currentOverviewId: null,
      chivoxRecorder: null,
      chivoxConfig: {
        appKey: '176474072400010f', // 需要填入实际的 appKey，例如: '176474072400010f'
        sigurl: 'https://reading.andover.com.cn/sig', // 需要填入实际的 sigurl，例如: 'php/sig.php' 或后端接口地址
        server: 'wss://cloud.chivox.com', // 标准服务器地址
        deviceId: 'device-' + Date.now(),
        userId: 'andover'
      },
      currentRecordingAudioBlob: null,
      isEvaluating: false,
      showStartButton: false, // 是否显示"开始测试"按钮
      showCountDown: false // 是否显示倒计时
    }
  },

  beforeMount: function () {
    // decode query string into object
    let queryString = window.atob(this.$route.query.encodedString)
    queryString = window.decodeURIComponent(queryString)
    this.decodedQueryObject = JSON.parse(queryString)
  },
  
  mounted: function () {
    document.addEventListener('keyup', this.handleAudioTestKeyUp)
    //set background color
    document
      .querySelector('body')
      .setAttribute('style', 'background-color: rgb(246, 247, 251)')

    //初始化用户角色
    this.userRole = localStorage.getItem('userRole')
    this.chivoxConfig.userId = localStorage.getItem('userId') || this.decodedQueryObject.studentId
    
    // 初始化 Chivox SDK
    this.initializeChivoxSDK()
    
    this.getTestById(
      this.decodedQueryObject.id,
      this.decodedQueryObject.studentId
    )
  },

  beforeUnmount: function () {
    document.removeEventListener('keyup', this.handleAudioTestKeyUp)
    // 清理 Chivox 资源
    this.cleanupChivox()
  },

  methods: {
    getTestById: function (testId, studentId) {
      this.$store
        .dispatch('StudentTest/getTestById', {
          id: testId,
          userId: studentId,
          includeAudio: false
        })
        .then(response => {
          //测试页面可能是从task任务进的，这时候decodedQueryObject不完整，需要补齐
          if (this.decodedQueryObject.task) {
            this.initializeDecodedQueryObject(response.data)
          }
          //状态是finished或者最后一个音频有东西，就跳转到结果页面
          if (
            response.data.status == 'finished' ||
            (response.data.studentAnswers[
              response.data.studentAnswers.length - 1
            ].audioBase64str &&
              response.data.studentAnswers[
                response.data.studentAnswers.length - 1
              ].audioBase64str.length > 0)
          ) {
            this.OpenInCurrentPageWithCryption(
              '/speakenglishtestitemresult',
              this.decodedQueryObject
            )
          } else {
            this.testItem = response.data
            this.initializeStartIndex()
            this.initializeTestCountDown()
            // 初始化完成后，判断是否是第一个单词
            this.$nextTick(() => {
              if (this.currentTestingVocIndex === 0) {
                // 第一个单词，显示"开始测试"按钮
                this.showStartButton = true
              } else {
                // 不是第一个单词，直接开始录音
                this.showStartButton = false
                this.showCountDown = false
                this.startNewWordFlow()
              }
            })
          }
        })
        .catch(error => {
          this.$message(error.toString())
        })
    },

    initializeDecodedQueryObject: function (testData) {
      let task = this.decodedQueryObject.task
      this.decodedQueryObject = testData
      this.decodedQueryObject.task = task || null
    },

    initializeTestCountDown: function () {
      // 看英说英模式，倒计时设置为5秒
      this.initialCountDownSetting = 5
    },

    initializeStartIndex: function () {
      // 要反着来，从最后一个null开始，直到碰见第一个不是null的值，就是开始的单词
      for (let i = this.testItem.studentAnswers.length - 1; i >= 0; i--) {
        if (
          this.testItem.studentAnswers[i].audioBase64str &&
          this.testItem.studentAnswers[i].audioBase64str.length > 0
        ) {
          // 有值说明已经回答过，下一个就是起始位置
          this.currentTestingVocIndex = i + 1
          return
        }
      }
      // 如果所有单词都没有答案，则从第一个开始
      this.currentTestingVocIndex = 0
    },

    processNextAudioItem: function () {
      // 进入下一个单词
      // 注意：答案已经在 onScore 回调中通过 submitChivoxEvaluationResultAfterScore 提交了
      // 这里不需要再次提交，直接进入下一个单词即可
      this.moveToNextWord()
    },

    moveToNextWord: function () {
      // 如果不是最后一个词，就进入下一个单词
      if (
        this.currentTestingVocIndex <
        this.testItem.studentAnswers.length - 1
      ) {
        // 进入下一个单词
        this.currentTestingVocIndex += 1
        // 隐藏开始按钮（如果显示）
        this.showStartButton = false
        this.showCountDown = false // 不显示倒计时
        // 直接开始新的单词流程（直接开始录音）
        this.startNewWordFlow()
      } else {
        // 最后一个单词，提交测试
        this.submit()
      }
    },

    handleStartTest: function () {
      // 点击"开始测试"按钮后，隐藏按钮并直接开始录音
      this.showStartButton = false
      this.showCountDown = false // 不显示倒计时
      // 直接开始录音，不需要倒计时
      this.startChivoxRecording()
    },

    startNewWordFlow: function () {
      // 开始新的单词流程：直接开始录音
      this.test.isRecording = false
      this.test.recordingCardInitialized = false
      this.showCountDown = false // 不显示倒计时
      
      // 直接开始录音
      this.startChivoxRecording()
    },

    implementNextBtnClick: function () {
      this.processNextAudioItem()
    },

    handleCountDownFinish: function () {
      // 倒计时结束后，如果正在录音，停止录音
      if (this.test.isRecording) {
        this.stopChivoxRecording()
      }
    },

    handleNextClick: function () {
      if (this.test.isRecording) {
        // 如果正在录音，停止录音
        this.stopChivoxRecording()
      } else {
        // 进入下一个单词
        this.implementNextBtnClick()
      }
    },

    initializeChivoxSDK: function () {
      try {
        // ===== 配置说明 =====
        // 请在此处填入实际的 Chivox 配置参数
        // 这些参数需要从 Chivox 开发者平台获取
        // 
        // 方式1：直接填写（不推荐，会暴露配置）
        // this.chivoxConfig.appKey = 'your-app-key'
        // this.chivoxConfig.sigurl = 'your-sig-url'
        // this.chivoxConfig.server = 'wss://cloud.chivox.com'  // 标准服务器地址
        //
        // 方式2：从环境变量或配置文件读取（推荐）
        // this.chivoxConfig.appKey = process.env.VUE_APP_CHIVOX_APP_KEY
        // this.chivoxConfig.sigurl = process.env.VUE_APP_CHIVOX_SIG_URL
        // this.chivoxConfig.server = process.env.VUE_APP_CHIVOX_SERVER || 'wss://cloud.chivox.com'
        //
        // 方式3：从后端接口获取（最安全）
        // 可以通过后端接口动态获取配置参数
        // ====================
        
        // 设置默认服务器地址（如果未配置）
        if (!this.chivoxConfig.server) {
          this.chivoxConfig.server = 'wss://cloud.chivox.com'
        }
        
        console.log('Chivox SDK 初始化准备中...')
        // Chivox SDK 的初始化在创建 Html5Recorder 时进行（在 startChivoxRecording 中）
      } catch (error) {
        console.error('Chivox SDK 初始化失败:', error)
        this.$message.error('语音评测初始化失败，请刷新页面重试')
      }
    },

    cleanupChivox: function () {
      if (this.chivoxRecorder) {
        try {
          if (this.test.isRecording) {
            this.chivoxRecorder.stopRecord()
          }
          if (typeof this.chivoxRecorder.reset === 'function') {
            this.chivoxRecorder.reset()
          }
          this.chivoxRecorder = null
        } catch (error) {
          console.error('清理 Chivox 资源失败:', error)
        }
      }
    },

    startChivoxRecording: function () {
      try {
        if (this.test.isRecording) {
          console.warn('已经在录音中')
          return
        }

        const currentWord = this.testItem.studentAnswers[this.currentTestingVocIndex]
        if (!currentWord || !currentWord.englishText) {
          console.error('当前单词不存在')
          return
        }

        // 检查必要的配置参数
        if (!this.chivoxConfig.appKey || !this.chivoxConfig.sigurl || !this.chivoxConfig.server) {
          console.error('Chivox 配置参数不完整，请检查 appKey、sigurl 和 server 配置')
          this.$message.error('语音评测配置未完成，请联系管理员')
          return
        }

        // 初始化 Html5Recorder - 根据标准示例代码
        this.chivoxRecorder = new Html5Recorder({
          server: this.chivoxConfig.server,
          alg: "sha1", //签名sig的加密类型，支持sha1、sha256、md5，默认sha1
          appKey: this.chivoxConfig.appKey,
          sigurl: this.chivoxConfig.sigurl,
          onInit: (mess) => {
            console.log('Chivox SDK onInit success:', mess)
            // SDK 初始化成功后，开始录音
            this.startChivoxRecord()
          },
          onError: (err) => {
            console.error('Chivox SDK onError:', err)
            this.test.isRecording = false
            this.isEvaluating = false
            this.$message.error('语音评测初始化失败: ' + (err.message || JSON.stringify(err)))
          }
        })
      } catch (error) {
        console.error('创建 Chivox Recorder 失败:', error)
        this.test.isRecording = false
        this.$message.error('启动录音失败: ' + (error.message || '未知错误'))
      }
    },

    startChivoxRecord: function () {
      try {
        const currentWord = this.testItem.studentAnswers[this.currentTestingVocIndex]
        const refText = currentWord.englishText

        // 先停止之前的录音（如果有）
        if (typeof this.chivoxRecorder.stopRecord === 'function') {
          this.chivoxRecorder.stopRecord()
        }

        // 注意：showVolumeBar() 需要提供容器元素，如果不需要显示波形图可以移除
        // 如果需要显示波形图，需要先添加一个容器元素，例如：
        // <div id="volumeBarContainer"></div>
        // 然后调用：this.chivoxRecorder.showVolumeBar('volumeBarContainer')

        // 开始录音 - 使用 record() 方法
        this.chivoxRecorder.record({
          duration: 5000, // 录音时长（毫秒），5秒后自动停止
          audioType: "wav",
          playDing: false, // 不播放叮声
          serverParams: {
            coreType: 'en.word.score', // 英文单词评分模式
            refText: refText, // 参考文本
            rank: 100, // 排名参数
            userId: this.chivoxConfig.userId || 'user-' + Date.now(),
            attachAudioUrl: 1 // 附加音频URL
          },
          onRecordIdGenerated: (tokenId) => {
            console.log('========onRecordIdGenerated start========')
            console.log(JSON.stringify(tokenId))
            console.log('========onRecordIdGenerated end========')
          },
          onStart: () => {
            console.log('录音开始')
            this.test.isRecording = true
            // 清空之前的评测结果
            const currentVoc = this.testItem.studentAnswers[this.currentTestingVocIndex]
            currentVoc.chivoxEvaluationResult = null
            currentVoc.overall = 0
            
            // 显示倒计时并启动5秒倒计时
            this.showCountDown = true
            this.$nextTick(() => {
              if (this.$refs.vocCountDown) {
                this.$refs.vocCountDown.countdown(5, true)
              }
            })
          },
          onStop: () => {
            console.log('录音停止')
            this.test.isRecording = false
            this.isEvaluating = true // 开始评测
            // 隐藏倒计时
            this.showCountDown = false
            // 停止倒计时组件
            if (this.$refs.vocCountDown) {
              this.$refs.vocCountDown.countdown(0, false)
            }
            // 尝试从录音器获取音频数据（如果支持）
            // 注意：根据 Chivox SDK 的实际 API 调整
            if (this.chivoxRecorder && typeof this.chivoxRecorder.getAudioBlob === 'function') {
              this.currentRecordingAudioBlob = this.chivoxRecorder.getAudioBlob()
            }
          },
          onScore: async (score) => {
            // 评测成功，获取评测结果
            console.log('========评测结果 start========')
            console.log(score.result)
            console.log('========评测结果 end========')

            this.isEvaluating = false
            const currentVoc = this.testItem.studentAnswers[this.currentTestingVocIndex]
            
            // 保存评测结果
            currentVoc.chivoxEvaluationResult = score.result
            currentVoc.audioUrl = score.audioUrl || ''
            
            // 提取分数并判断是否正确
            const overallScore = score.result.overall || 0
            currentVoc.isCorrect = overallScore >= 70 // 70分以上算正确

            // 方式1: 从评测结果中的 audioUrl 下载音频并转换为 base64
            let audioBase64 = ''
            if (score && score.audioUrl) {
              console.log('从 audioUrl 获取音频:', score.audioUrl)
              try {
                audioBase64 = await this.fetchAudioFromUrl(score.audioUrl)
                console.log('成功获取音频 base64，长度:', audioBase64.length)
                // 保存音频 base64 到当前单词
                currentVoc.audioBase64str = audioBase64
              } catch (error) {
                console.error('从 audioUrl 下载音频失败:', error)
                this.$message.warning('获取录音音频失败，但评测结果已保存')
              }
            } else {
              console.warn('评测结果中未找到 audioUrl')
            }

            console.log("score:", score)
            // 提交评测结果和音频到后端
            await this.submitChivoxEvaluationResultAfterScore(score.result, audioBase64)
          },
          onScoreError: (err) => {
            // 评测失败
            console.error('评测失败:', err)
            this.test.isRecording = false
            this.isEvaluating = false
            this.$message.error('评测失败: ' + (err.message || JSON.stringify(err)))
            
            // 重置录音器
            if (typeof this.chivoxRecorder.reset === 'function') {
              this.chivoxRecorder.reset()
            }
          }
        })
      } catch (error) {
        console.error('启动录音失败:', error)
        this.test.isRecording = false
        this.$message.error('启动录音失败: ' + (error.message || '未知错误'))
      }
    },

    stopChivoxRecording: function () {
      try {
        if (!this.test.isRecording || !this.chivoxRecorder) {
          return
        }
        // 停止倒计时
        if (this.$refs.vocCountDown) {
          this.$refs.vocCountDown.countdown(0, false)
        }
        this.showCountDown = false
        // 使用 stopRecord() 方法停止录音
        if (typeof this.chivoxRecorder.stopRecord === 'function') {
          this.chivoxRecorder.stopRecord()
        }
        this.test.isRecording = false
      } catch (error) {
        console.error('停止 Chivox 录音失败:', error)
        this.test.isRecording = false
        this.showCountDown = false
      }
    },

    blobToBase64: function (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
          const base64String = reader.result.split(',')[1] // 移除 data:audio/wav;base64, 前缀
          resolve(base64String)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },

    fetchAudioFromUrl: async function (audioUrl) {
      // 从音频 URL 下载音频并转换为 base64
      try {
        const response = await fetch(audioUrl)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const blob = await response.blob()
        const base64 = await this.blobToBase64(blob)
        return base64
      } catch (error) {
        console.error('从 URL 下载音频失败:', error)
        throw error
      }
    },

    submitChivoxEvaluationResultAfterScore: async function (evaluationResult, audioBase64) {
      try {
        const currentVoc = this.testItem.studentAnswers[this.currentTestingVocIndex]
        
        // 确保 audioBase64str 已保存（在 onScore 中已保存，这里再次确认）
        if (audioBase64 && !currentVoc.audioBase64str) {
          currentVoc.audioBase64str = audioBase64
        }
        
        // 提交到后端
        await this.postVocStudentTestVocabularyAnswer({
          id: currentVoc.id,
          listeningCount: currentVoc.listeningCount || 0,
          audioBase64str: currentVoc.audioUrl, // 提交 audioUrl 而非 base64
          aIcheckResult: evaluationResult, //这里因为后端还没更新chivoxEvaluationResult，所以先提交aIcheckResult
          isCorrect: currentVoc.isCorrect || false
        })
        
        console.log('评测结果和音频已提交到后端，audioBase64str 长度:', (audioBase64 || currentVoc.audioBase64str || '').length)
        
        // 提交成功后，自动进入下一个单词
        this.$nextTick(() => {
          this.moveToNextWord()
        })
      } catch (error) {
        console.error('提交评测结果失败:', error)
        this.$message.error('提交评测结果失败，请重试')
        throw error
      }
    },

    getEvaluationScore: function (evaluationResult) {
      if (!evaluationResult) return 0
      // 根据实际的评测结果结构获取分数
      // 可能的结构：evaluationResult.overall, evaluationResult.score, evaluationResult.totalScore 等
      return evaluationResult.overall || 
             evaluationResult.score || 
             evaluationResult.totalScore || 
             evaluationResult.pronunciationScore || 
             0
    },

    postVocStudentTestVocabularyAnswer: function (postData) {
      return new Promise((resolve, reject) => {
        // 将 chivoxEvaluationResult 映射到后端的 AIcheckResult 字段
        const submitData = {
          id: postData.id,
          listeningCount: postData.listeningCount || 0,
          audioBase64str: postData.audioBase64str || '',
          isCorrect: postData.isCorrect || false,
          // 将 Chivox 评测结果作为 JSON 字符串存储到 AIcheckResult 字段
          aIcheckResult: postData.aIcheckResult ? JSON.stringify(postData.aIcheckResult) : null
        }
        
        this.$store
          .dispatch('StudentTest/editVocStudentTestVocabularyAnswer', submitData)
          .then(response => {
            if (response.data === true) {
              // 静默提交，不显示成功消息
              // this.$message.success('词汇已提交')
            } else {
              this.$message.error('词汇未提交，请检查网络是否稳定')
            }
            resolve(response)
          })
          .catch(error => {
            this.$message.error('词汇未提交，请检查是否已作答')
            reject(error)
          })
      })
    },

    tagVoc: function (vocabularyId, studentId) {
      let postData = {
        vocabularyId: vocabularyId,
        userId: studentId,
        vocTagId: 1,
        deleted: false
      }
      this.$store
        .dispatch('Vocabulary/tagVocabulary', postData)
        .then(() => {})
        .catch(error => console.log(error.toString()))
    },

    submit: function () {
      this.decodedQueryObject.submitted = true
      this.finalUpdateTestStatus()
    },

    finalUpdateTestStatus: function () {
      this.addStudentOverview()
        .then(() => {
          this.$store
            .dispatch('StudentTest/updateStudentTestStatus', {
              id: this.testItem.id,
              studentId: this.testItem.studentId,
              name: this.testItem.name,
              type: this.testItem.type,
              origin: this.testItem.origin,
              nirvanaCount: 0,
              description: this.testItem.description || '',
              status: 'finished',
              published: true
            })
            .then(response => {
              if (response.data != -1) {
                this.submitted = true
                this.OpenInCurrentPageWithCryption(
                  '/speakenglishtestitemresult',
                  this.decodedQueryObject
                )
              }
            })
            .catch(error => this.$message(error.toString()))
        })
        .catch(error => this.$message(error.toString()))
    },

    addStudentOverview: function () {
      return new Promise((resolve, reject) => {
        let postData = {
          studentId: this.testItem.studentId,
          vocTestId: this.testItem.id,
          learningMode: '看英说英',
          checkingMode: this.testItem.type.toString(),
          vocSetNames: this.testItem.origin
        }

        this.$store
          .dispatch('StudentOverview/addVocStudentOverview', postData)
          .then(response => {
            if (response.data != -1) {
              this.currentOverviewId = response.data
              resolve(response)
            }
          })
          .catch(error => {
            console.log(error.toString())
            reject(error)
          })
      })
    },

    OpenInCurrentPageWithCryption: function (routeName, query) {
      query = JSON.stringify(query)
      query = window.encodeURIComponent(query)
      this.$router.push({
        path: routeName,
        query: { encodedString: window.btoa(query) }
      })
    },

    handleAudioTestKeyUp: function (event) {
      switch (event.keyCode) {
        case 13:
          this.handleNextClick()
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
div#outsideContainer {
  font: bold 24pt sans;
  color: deepskyblue;
}

.test-progress {
  font: 500 18pt sans;
}

.card-wrapper {
  display: flex;
  flex-flow: row wrap;
  height: 100%;
  margin-top: 10%;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.card-wrapper > * {
  flex: 1 100%;
}

.card-content {
  border-radius: 5px 5px 0 0;
  margin-left: 19%;
  margin-right: 19%;
  background-color: white;
  box-shadow: 0 0.25rem 1rem 0 rgba(48, 53, 69, 0.08);
  height: 400px;
}

.card-items {
  margin-top: 1.5rem;
}

.test-english-word {
  margin: 2rem 0;
  
  .english-word-text {
    font-size: 48px;
    font-weight: bold;
    color: #303133;
    text-align: center;
    margin: 0;
  }
}

.test-audio-icon {
  cursor: pointer;
  color: orange;
  margin-top: 1rem;
}

.test-item {
  margin-top: 2rem;
}

.count-down-text {
  font: bold 28pt sans;
}

.test-listening-count {
  font: 100 12pt sans;
}

.audio-text {
  color: rgb(189, 122, 246, 0.8);
  font: 600 20pt sans;
}

.recording-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 18px;
  color: #f56c6c;
  
  .recording-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #f56c6c;
    animation: pulse 1.5s ease-in-out infinite;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
}

.evaluating-indicator {
  text-align: center;
  font-size: 16px;
  color: #409eff;
}

.evaluation-result {
  text-align: center;
  
  .result-info {
    font-size: 20px;
    color: #67c23a;
    font-weight: bold;
  }
}

.start-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
</style>

